import ReactGA from 'react-ga4';

// Google Analytics Measurement ID
const measurementId = process.env.REACT_APP_GA_ID;

// Initialize Google Analytics
export const initGA = () => {
  ReactGA.initialize(measurementId);
};

// Track page views
export const logPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

//Item View
export const trackItemView = (cabinetData) => {
  const payload = {
    event: 'view_item',
    ecommerce: {
      currency: 'USD',
      value: cabinetData?.startingPrice,
      items: [
        {
          item_id: cabinetData?.id,
          item_name: cabinetData?.shortName,
          item_variant: cabinetData?.type,
          price: cabinetData?.startingPrice,
          quantity: 1,
        },
      ],
    },
  };

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(payload);
};

// Add to Cart
export const trackAddToCart = (projectData, cartTotal) => {
  const payload = {
    event: 'add_to_cart',
    ecommerce: {
      currency: 'USD',
      value: cartTotal,
      items: projectData?.cabinets?.map((item) => ({
        item_id: item?.id,
        item_name: item?.shortName,
        item_variant: item?.catalog,
        price: item?.itemTotal,
        quantity: item?.quantity,
      })),
    },
  };

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(payload);
};

// // Remove from Cart
// export const trackRemoveFromCart = (projectData) => {
//   dataLayer.push({ ecommerce: null });
//   dataLayer.push({
//     event: 'remove_from_cart',
//     ecommerce: {
//       item_list_id: projectData.id,
//       item_list_name: projectData.longName,
//       items: projectData,
//     },
//   });
// };

//Begin Checkout
export const trackCheckout = (checkoutData) => {
  const payload = {
    event: 'begin_checkout',
    ecommerce: {
      currency: 'USD',
      value: checkoutData?.cartSubtotal,
      items: checkoutData?.projectData?.map((item) =>
        item?.cabinetList?.map((cabinetItem) => ({
          item_id: cabinetItem?.id,
          item_name: cabinetItem?.shortName,
          item_variant: cabinetItem?.type,
          price: cabinetItem?.itemTotal,
          quantity: cabinetItem?.quantity,
        }))
      ),
    },
  };

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(payload);
};

//Add Shipping info
export const trackShippingInformation = (shippingData) => {
  const payload = {
    event: 'add_shipping_info',
    ecommerce: {
      currency: 'USD',
      value: shippingData?.cartSubtotal,
      items: shippingData?.projectData?.map((item) =>
        item?.cabinetList?.map((cabinetItem) => ({
          item_id: cabinetItem?.id,
          item_name: cabinetItem?.shortName,
          item_variant: cabinetItem?.type,
          price: cabinetItem?.itemTotal,
          quantity: cabinetItem?.quantity,
        }))
      ),
    },
  };

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(payload);
};

//Add Payment Info
export const trackPaymentInformation = (paymentData) => {
  const payload = {
    event: 'add_payment_info',
    ecommerce: {
      currency: 'USD',
      value: paymentData?.cartSubtotal,
      items: paymentData?.projectData?.map((item) =>
        item?.cabinetList?.map((cabinetItem) => ({
          item_id: cabinetItem?.id,
          item_name: cabinetItem?.shortName,
          item_variant: cabinetItem?.type,
          price: cabinetItem?.itemTotal,
          quantity: cabinetItem?.quantity,
        }))
      ),
    },
  };

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(payload);
};

//Purchase
export const trackOrderPlaced = (orderData) => {
  const payload = {
    event: 'purchase',
    ecommerce: {
      currency: 'USD',
      value: orderData?.cartSubtotal,
      items: orderData?.projectData?.map((item) =>
        item?.cabinetList?.map((cabinetItem) => ({
          item_id: cabinetItem?.id,
          item_name: cabinetItem?.shortName,
          item_variant: cabinetItem?.type,
          price: cabinetItem?.itemTotal,
          quantity: cabinetItem?.quantity,
        }))
      ),
    },
  };

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(payload);
};
